import { Controller } from "stimulus"

export default class extends Controller {
  static values = { subjectField: String, filter: Object }
  static get targets() {
    return [];
  }

  connect(){
    if (this.hasSubjectFieldValue) {
      $(this.subjectFieldValue).on('change', ()=>{ this.reloadOptions(); });
    }
  }

  replacePlacesOptions(data) {
    let selector = $(this.element);
    selector.empty();
    _.each(data, (place)=>{
      let value = place.selectvalue || place.id;
      let place_option = $('<option>').
                           attr("value", value).
                           text(place.fulldescription).
                           data('id', place.id).
                           data('type', place.type).
                           data('code', place.code);
      selector.append(place_option);      
    });
    let placesReloadedEvent = new CustomEvent("places-reloaded");
    window.dispatchEvent(placesReloadedEvent);
    
  }
  reloadOptions(event) { 
    let filter = (this.hasFilterValue ? this.filterValue : {});
    if (this.hasSubjectFieldValue && $(this.subjectFieldValue).val()) {
      filter['subject_id'] = $(this.subjectFieldValue).val();
    }
    $.get({
        url: "/operations/places.json",
        data: filter 
     })
     .done(( data )=>{
       this.replacePlacesOptions(data);
     });
  }
}
